import React, { FC } from "react";

import { getYearMonth } from "services/TextPrettierService";

const YearMonthDisplay: FC<{ months: number }> = (props) => {
  return (
    <div className="year-month-display text text--secondary fw--600">
      {getYearMonth(props.months)}
    </div>
  );
};

export default YearMonthDisplay;
